import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { installStudyImageCacheReset } from "./features/study/lib/studyImageCacheReset";
import "./shared/ui/tokens.css";
import "./shared/ui/global.css";
import "./shared/ui/studyTheme.css";

// サインアウトで学習系の画像キャッシュ (紙面の object URL) を捨てる購読。起動時に 1 回だけ張る。
installStudyImageCacheReset();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("root element not found");
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
